import Vue from "vue";
import ExcelJS from "./exceljs";

Vue.use(ExcelJS);